module.exports = __webpack_public_path__ + "img/3.d8b5a1b8.webp";